function isPWA() {
    return window.matchMedia('(display-mode: standalone)').matches ||
        window.navigator.standalone === true;
}

if (isPWA()) {
    const progressBar = document.getElementById('pwa-progress-bar');
    let progressInterval = null;
    let currentProgress = 0;

    // Show a progress bar on navigation
    function showProgress() {
        currentProgress = 0;
        progressBar.style.width = '0%';
        progressBar.classList.remove('complete');
        progressBar.classList.add('loading');

        // Simulate progressive loading
        progressInterval = setInterval(() => {
            if (currentProgress < 90) {
                // Slow down as we approach 90%
                const increment = Math.random() * (20 - currentProgress / 10);
                currentProgress += increment;
                progressBar.style.width = currentProgress + '%';
            }
        }, 200);
    }

    // Complete progress bar
    function completeProgress() {
        clearInterval(progressInterval);
        currentProgress = 100;
        progressBar.style.width = '100%';

        setTimeout(() => {
            progressBar.classList.add('complete');
            setTimeout(() => {
                progressBar.classList.remove('loading', 'complete');
            }, 500);
        }, 200);
    }

    // Intercept all link clicks
    document.addEventListener('click', (e) => {
        const link = e.target.closest('a');

        // Only handle internal navigation links
        if (link &&
            link.href &&
            !link.target &&
            link.href.startsWith(window.location.origin) &&
            !link.hasAttribute('download') &&
            !link.href.includes('#')) {

            showProgress();
        }
    });

    // Also handle form submissions
    document.addEventListener('submit', (e) => {
        showProgress();
    });

    // Complete on page load
    window.addEventListener('load', () => {
        completeProgress();
    });

    // Handle browser back/forward
    window.addEventListener('pageshow', (e) => {
        if (e.persisted) {
            completeProgress();
        }
    });

    // Fallback: auto-complete after 15 seconds
    document.addEventListener('click', (e) => {
        const link = e.target.closest('a');
        if (link && link.href && link.href.startsWith(window.location.origin)) {
            setTimeout(() => {
                if (progressBar.classList.contains('loading')) {
                    completeProgress();
                }
            }, 15000);
        }
    });
}
